/* eslint-disable react/jsx-pascal-case */
import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { useDispatch, useSelector } from 'store'
import T_Main from 'components/4_Templates/T_Main'
import O_SearchBoxLog from 'components/3_Organisms/Groups/O_SearchBoxLog'
import O_TableLog from 'components/3_Organisms/Groups/O_TableLog'
import * as LoginAction from 'slicers/LoginSlice'
import * as PageAction from 'slicers/PageSlice'
import { useInitProcess, useSearch } from 'hooks/useLog'
import { getMenuLabel } from 'utils/stringUtil'
import { labels } from 'types/ReferTypes'
import O_AddUser from 'components/3_Organisms/Groups/O_AddUser'
import O_AddUserTokui from 'components/3_Organisms/Groups/O_AddUserTokui'

const P_Log = ({ labels }: { labels: labels }) => {
  const dispatch = useDispatch()
  const loginKbn = useSelector((state) => state.LoginReducer.loginKbn)
  const initProcess = useInitProcess()
  const history = useHistory()
  useEffect(() => {
    if (loginKbn !== 2) {
      dispatch(LoginAction.format())
      history.push('/') // ログイン画面に遷移
    } else {
      dispatch(PageAction.deleteMessage())
    }
    initProcess()
  }, [])

  const isJapell = useSelector((state) => state.LoginReducer.isJapell)
  const initView = useSelector((state) => state.SearchLogReducer.initView)
  const page = useSelector((state) => state.TableReducer.page)
  const perPage = useSelector((state) => state.TableReducer.perPage)
  const [clickSearch] = useSearch()
  useEffect(() => {
    // ページ変更時の検索
    if (perPage === 100) clickSearch()
  }, [perPage, page])
  const data = useSelector((state) => state.TableLogReducer.logList)

  return (
    <T_Main labels={labels} pageTitle={getMenuLabel(labels.sideMenus[3])}>
      {initView === 0 ? (
        <>Loading...</>
      ) : (
        <>
          {!isJapell ? (
            <></>
          ) : (
            <>
              <O_SearchBoxLog />
              <hr />
            </>
          )}
          <O_TableLog logList={data} />
        </>
      )}
      {/* アラートダイアログ */}
      {isJapell ? <O_AddUser refetch={() => {}} /> : <O_AddUserTokui refetch={clickSearch} />}
    </T_Main>
  )
}

export default P_Log
